export const arraysAreEqual = (array1?: unknown[] | null, array2?: unknown[] | null): boolean => {
  if (!Array.isArray(array1) || !Array.isArray(array2) || array1.length !== array2.length) {
    return false;
  }

  return array1.every((value, index) => value === array2[index]);
};

export const keepOnlyUniqueElements = <T>(array: readonly T[]) => Array.from(new Set(array));
